import { useState } from "react";
import { useLocation } from "wouter";
import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import { api, ApiError } from "@/lib/api";
import { setAccessToken } from "@/lib/auth";
import { useSiteSettings } from "@/lib/cms";

export function AdminLogin() {
  const { t } = useTranslation();
  const [, navigate] = useLocation();
  const { brand } = useSiteSettings();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const login = useMutation({
    mutationFn: () =>
      api<{ token: string }>("/api/auth/login", {
        method: "POST",
        withAuth: false,
        body: { email, password },
      }),
    onSuccess: (data) => {
      setAccessToken(data.token);
      navigate("/admin");
    },
  });

  return (
    <div className="min-h-screen grid place-items-center bg-brand-50 px-4">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          login.mutate();
        }}
        className="w-full max-w-sm card p-8"
      >
        <div className="text-center mb-6">
          <div className="w-12 h-12 rounded-lg bg-brand-900 text-white grid place-items-center font-bold mx-auto">
            {brand.logoLetter}
          </div>
          <h1 className="mt-4 text-xl font-semibold">{t("admin.login.title")}</h1>
          <p className="mt-1 text-sm text-brand-500">{brand.name}</p>
        </div>

        <div className="space-y-4">
          <div>
            <label htmlFor="email" className="label">
              {t("admin.login.email")}
            </label>
            <input
              id="email"
              type="email"
              required
              autoFocus
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
            />
          </div>
          <div>
            <label htmlFor="password" className="label">
              {t("admin.login.password")}
            </label>
            <input
              id="password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input"
            />
          </div>

          {login.isError && (
            <div className="text-sm text-red-600">
              {login.error instanceof ApiError && login.error.status === 401
                ? t("admin.login.error")
                : "Hiba történt"}
            </div>
          )}

          <button
            type="submit"
            disabled={login.isPending}
            className="btn-primary w-full"
          >
            {login.isPending ? t("contact.form.sending") : t("admin.login.submit")}
          </button>
        </div>
      </form>
    </div>
  );
}
